module.exports = __webpack_public_path__ + "static/media/taxi.5e7a003f.svg";